<template>
  <div class="main-report">
    <nav-bar
      :title="$route.query.title || $t('reportIndex.工单')"
      :showBack="false"
    />
    <div class="content">
      <van-form ref="form" @submit="handleSubmit">
        <template v-for="(item, index) in fieldData">
          <div
            class="tips"
            :key="index"
            v-if="item.type === 'tip'"
            v-html="item.show_name"
          ></div>
          <div v-else :key="index" class="field-item">
            <span class="label"
              ><span v-if="item.is_must" class="red">* </span
              >{{ item.show_name }}：</span
            >
            <!-- 单选与多选已取消，不用判断-->
            <van-field
              :class="
                !['input', 'text', 'phone', 'role', 'role2'].includes(item.type)
                  ? 'select-field'
                  : 'input-field'
              "
              :readonly="
                !['input', 'text', 'phone', 'role2'].includes(item.type)
              "
              :clickable="
                !['input', 'text', 'phone', 'role2'].includes(item.type)
              "
              @click="onClickItem(item, index)"
              v-model="item.form.text"
              :name="typeToForm[item.type]"
              :placeholder="item.notice_val"
              :rules="[
                {
                  required: item.is_must == 1 ? true : false,
                  message: $t('reportIndex.请填写内容'),
                },
              ]"
            >
              <template #input v-if="item.type === 'files'">
                <van-uploader
                  accept="*"
                  v-model="item.form.value"
                  :after-read="afterRead"
                  :before-read="beforeRead"
                />
              </template>
            </van-field>
          </div>
        </template>
      </van-form>
    </div>
    <div class="footer">
      <van-button
        :disabled="!ticketModel.name"
        :loading="comLoading"
        block
        class="submit-btn"
        size="large"
        type="primary"
        @click="submit"
      >
        {{ $t("reportIndex.提交") }}
      </van-button>
    </div>
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentTime"
        :title="$t('reportIndex.选择日期')"
        :type="dateType"
        :min-date="minDate"
        @confirm="onConfirm"
        @cancel="showTimePicker = false"
      />
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :confirm-button-text="$t('app.确认')"
        :cancel-button-text="$t('app.取消')"
        :columns="currentColumns"
        @confirm="onConfirm"
        :loading="pickerLoading"
        @cancel="showPicker = false"
      >
        <van-search
          slot="title"
          v-model="keyword"
          :placeholder="$t('reportIndex.请输入搜索关键词')"
        />
      </van-picker>
    </van-popup>
    <NormalNotice
      :visible="showDescription"
      :data="description"
      :top="noticeTop"
      @close="showDescription = false"
    />
  </div>
</template>

<script>
import {
  getPublicTicketfield,
  getPublicSubmitTiket,
  getPublicGetDecodeInfo,
} from "@/api/workOrder";
import { NormalNotice } from "@/components/Notice";
import { getServerList, getServerTypeList } from "@/api/user";
import { uploadFileOss } from "@/utils/uploadOss";
import { mapGetters, mapActions } from "vuex";
import dayjs from "dayjs";
import storage from "@/utils/storage";

export default {
  name: "Report",
  data() {
    return {
      keyword: "",
      // 描述显示
      showDescription: false,
      currentTime: null,
      // 描述内容
      description: {},
      submitLoading: false,
      dateType: "time",
      typeToForm: {
        input: "input",
        text: "textarea",
        select: "textarea",
        phone: "input",
        service: "picker",
        files: "uploader",
        date: "datetimePicker",
        datetime: "datetimePicker",
        role: "input",
      },
      columns: [],
      showTimePicker: false,
      showPicker: false,
      uploader: [],
      fieldData: null,
      activeIndex: 0,
      serverType: [],
      minDate: new Date(1950, 0, 1),
      pickerLoading: false,
      comLoading: false,
      ticketModel: { name: "" },
      isChageModel: false,
      form_id: "",
      acceptFile: "",
      gameId: "",
      currentCode: "",
      defaultRoleInfo: {},
    };
  },
  components: { NormalNotice },
  computed: {
    ...mapGetters(["vuexInitData"]),
    noticeTop() {
      // let height =
      //   (document.getElementsByClassName("nav-bar")[0] &&
      //     document.getElementsByClassName("nav-bar")[0].offsetHeight) ||
      //   44;
      return 0;
    },
    currentColumns() {
      return this.columns.filter((item) => {
        const str = (item.text && item.text.toLowerCase()) || "";
        return str.includes(this.keyword.toLowerCase());
      });
    },
  },
  watch: {
    showPicker: {
      handler(val) {
        if (!val) {
          this.keyword = "";
        }
      },
    },
  },
  async mounted() {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("iphone") != -1) {
      this.acceptFile = "";
    } else {
      this.acceptFile =
        "image/png,image/jpg,image/jpeg,image/gif,video/mp4,video/mov,video/m4v,video/avi,video/mkv,video/flv,video/wmv";
    }
    const { id, formToken, title, game_id, msign } = this.$route.query;
    if (id && formToken && game_id && msign) {
      sessionStorage.setItem("game_id", Number(game_id));
      this.currentCode = msign;
      this.form_id = id;
      this.gameId = game_id;
      await this.getKfInit();
      await this.getRoleInfos();
      this.ticketModel.name = title;
      await this.getFieldData({ id, token: formToken });
    }
  },
  methods: {
    ...mapActions(["getKfInit"]),
    async getRoleInfos() {
      // 获取从摸鱼社带过来的code解析出来的玩家信息
      const res = await getPublicGetDecodeInfo({ code: this.currentCode });
      if (res && res.code === 0 && res.data && res.data.info) {
        this.defaultRoleInfo = res.data.info;
      }
    },
    beforeRead(file) {
      // 判断文件类型是否为图片或者视频
      if (file.type.includes("image") || file.type.includes("video")) {
        return true;
      } else {
        this.$toast(this.$t("login.typeError"));
        return false;
      }
    },
    afterRead(file) {
      console.log({ file });
      file.status = "uploading";
      file.message = this.$t("reportIndex.上传中") + "...";
      let params = {
        file: file.file,
        accept: "png,jpg,jpeg,gif,mp4,mov,m4v,avi,mkv,flv,wmv",
      };
      const _this = this;
      uploadFileOss(params)
        .then((res) => {
          file.status = "success";
          file.message = "";
          file.url = res.key;
        })
        .catch((err) => {
          file.status = "failed";
          file.message = _this.$t("reportIndex.上传失败");
          this.$toast(_this.$t("reportIndex.上传失败"));
        });
    },
    // 获取服务器类型
    getServerType() {
      getServerTypeList({ game_id: this.gameId }).then((res) => {
        if (res.code === 0) {
          res.data.forEach((item) => {
            item.text = item.name;
          });
          this.serverType = res.data;
        }
      });
    },
    // 区服列表请求后，直接添加到 picker 列表
    getServerList(id) {
      this.pickerLoading = true;
      getServerList({ server_type: id, game_id: this.gameId })
        .then((res) => {
          if (res.code === 0) {
            res.data.forEach((item) => {
              item.text = item.name;
              item.value = item.id;
            });
            this.columns = res.data;
          }
        })
        .finally(() => {
          this.pickerLoading = false;
        });
    },
    async getFieldData(params) {
      const curParams = {
        ...params,
        game_id: this.gameId,
      };
      await getPublicTicketfield(curParams).then((res) => {
        if (res.code === 0) {
          const { items, description } = res.data || {};
          items.forEach((item) => {
            item.form = { text: "", value: "" };
            if (item.option_val) {
              item.selectOption = JSON.parse(item.option_val).map((item) => {
                item.text = item.key;
                item.value = item.val;
                return item;
              });
            }
            if (item.type === "files") {
              item.form = { text: "", value: [] };
            }
            // 判断有没有需要区服的字段
            if (item.type === "service") {
              if (this.defaultRoleInfo && this.defaultRoleInfo.serverId) {
                item.form = {
                  text: this.defaultRoleInfo.serverName || "",
                  value:
                    (this.defaultRoleInfo.serverId &&
                      Number(this.defaultRoleInfo.serverId)) ||
                    "",
                };
              }
              this.getServerType();
            }
            // 判断电话号码
            if (item.type === "phone") {
              if (this.defaultRoleInfo && this.defaultRoleInfo.mobile) {
                item.form = {
                  text: this.defaultRoleInfo.mobile || "",
                  value: "",
                };
              }
            }

            // 判断角色名
            if (item.type === "role") {
              if (this.defaultRoleInfo && this.defaultRoleInfo.roleId) {
                item.form = {
                  text: this.defaultRoleInfo.roleName || "",
                  value: this.defaultRoleInfo.roleId || "",
                };
              }
            }

            this.currentTime = new Date();
          });
          this.fieldData = items;
          if (description) {
            this.description = {
              title: this.$route.query.title,
              content: description,
            };
            this.showDescription = true;
          }
        }
      });
    },
    onClickItem(item, index) {
      this.activeIndex = index;
      if (item.type === "date" || item.type === "datetime") {
        this.dateType = item.type;
        this.showTimePicker = true;
      } else if (item.type === "select") {
        this.showPicker = true;
        this.columns = item.selectOption;
      }
      // else if (item.type === 'service') {
      //   this.showPicker = true;
      //   this.columns = this.serverType;
      // }
    },
    onConfirm(value) {
      this.keyword = "";
      if (this.showTimePicker) {
        this.showTimePicker = false;
        if (this.dateType === "date") {
          this.fieldData[this.activeIndex].form.text = dayjs(value).format(
            "YYYY-MM-DD"
          );
        } else {
          this.fieldData[this.activeIndex].form.text = dayjs(value).format(
            "YYYY-MM-DD HH:mm"
          );
        }
      } else if (this.showPicker) {
        // 选区服类型，再选区服
        if (this.columns === this.serverType) {
          this.getServerList(value.id);
        } else if (this.isChageModel) {
          this.ticketModel = value;
          this.showPicker = false;
          this.isChageModel = false;
          this.form_id = value.form_id;
          this.getFieldData({ id: value.form_id, token: value.token });
        } else {
          this.showPicker = false;
          this.fieldData[this.activeIndex].form = value;
        }
      }
    },
    submit() {
      this.$refs.form.submit();
    },
    handleSubmit(value) {
      let params = {};
      this.fieldData
        .filter((item) => {
          if (item.type !== "tip") return true;
        })
        .forEach((item) => {
          if (item.type === "select") {
            // select  给后端 text 直接显示
            params[item.key.trim()] = item.form.text || item.form.value || "";
          } else {
            params[item.key.trim()] = item.form.value || item.form.text || "";
          }
        });

      if (params.files && params.files.length > 0) {
        if (!params.files.every((item) => item.status === "success")) {
          this.$toast(this.$t("reportIndex.文件上传中"));
          return;
        }
        params.files = params.files.map((item) => {
          return item.url;
        });
      }

      params.form_id = Number(this.form_id);
      params.role_name = this.defaultRoleInfo.roleName;

      this.comLoading = true;
      getPublicSubmitTiket(params)
        .then((res) => {
          if (res.code === 0) {
            window.staticFn.customEvent("submit_report", {
              type: "public_report",
              game_id: this.gameId,
              form_id: this.form_id,
              role_name: params.role_name,
            });
            this.$router.replace({
              name: "PublicReportResult",
              query: {
                title: this.$route.query.title,
              },
            });
          }
        })
        .finally(() => {
          this.comLoading = false;
        });
    },
    handleConfirm() {
      window.open("https://docs.qq.com/doc/DWkJoQ3JNbXJyYWtB", "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.main-report {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;

  .tip-content {
    padding: 8px 20px 26px;
    color: #646566;
    font-size: 14px;
    text-align: center;
  }

  .content {
    flex: 1;
    margin-top: 8px;
    padding: 12px 10px;
    box-sizing: border-box;
    background-color: #fff;
    .field-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
      .label {
        // min-width: 84px;
        // margin-right: 5px;
        margin-bottom: 8px;
        color: #555;
        font-size: 14px;
      }
      .input-field {
        border: 1px solid rgba(0, 0, 0, 0.04);
        box-sizing: border-box;
      }
      .select-field {
        background-color: #fbfbfb;
        box-sizing: border-box;
      }
    }
  }

  .footer {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    // height: 60px;
    padding: 20px 10px;
    box-sizing: border-box;
    background-color: #fff;
    .submit-btn {
      height: 40px;
      font-size: 15px;
      font-weight: 500;
    }
  }

  .tips {
    margin-bottom: 10px;
    padding: 6px 20px;
    color: red;
    font-size: 12px;
    line-height: 22px;
    font-weight: 500;
    background-color: #fff6e5;
    border-radius: 6px;
    border: 1px solid @gold;
  }
  /deep/ .van-search {
    padding: 0;
  }
}
</style>
